'use strict'

import CloudDataConnector from '../api.js'
import Plot from './base.js'

export default class PlotFrogLaying extends Plot {
  constructor () {
    super('frogs-laying')
  }

  async dataFunction (controller) {
    // Get data from API
    const [ vallorcineResponse, loriazResponse ] = await Promise.all([
      new CloudDataConnector().getFrogsAnnualMeanLaying('Vallorcine'),
      new CloudDataConnector().getFrogsAnnualMeanLaying('Loriaz')
    ])
    const height = controller.uiParams.height

    const vallorcineData = vallorcineResponse.sort((left, right) => left.date < right.date ? -1 : (left.date > right.date ? 1 : 0))
    const loriazData = loriazResponse.sort((left, right) => left.date < right.date ? -1 : (left.date > right.date ? 1 : 0))

    const vallorcineDataDate = vallorcineData.map(item => new Date(item.date))
    const loriazDataDate = loriazData.map(item => new Date(item.date))

    const milliSecondsInDays = 1000 * 60 * 60 * 24

    // Compute laying day in julian day
    const vallorcineDataPoints = vallorcineDataDate.map((item, index) => (item.getTime() - new Date(item.getFullYear().toString()).getTime()) / milliSecondsInDays)
    const loriazDataPoints = loriazDataDate.map((item, index) => (item.getTime() - new Date(item.getFullYear().toString()).getTime()) / milliSecondsInDays)

    // Build labels for understanding
    // const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
    const vallorcineTexts = vallorcineDataDate.map(item => item.getDate() + ' ' + monthNames[item.getMonth()])
    const loriazTexts = loriazDataDate.map(item => item.getDate() + ' ' + monthNames[item.getMonth()])

    const xaxisVallorcine = vallorcineData.map(item => item.year)
    const xaxisLoriaz = loriazData.map(item => item.year)

    // Return elements to give to Plotly
    return {
      data: [
        {
          x: xaxisVallorcine,
          y: vallorcineDataPoints,
          mode: 'lines+markers+text',
          text: vallorcineTexts,
          textposition: 'top',
          name: 'Vallorcine (1300 m)',
          marker: { color: '#059180', size: 8 },
          line: { color: '#059180', width: 1 }
        },
        {
          x: xaxisLoriaz,
          y: loriazDataPoints,
          mode: 'lines+markers+text',
          text: loriazTexts,
          textposition: 'top',
          name: 'Loriaz (1900 m)',
          marker: { color: '#00afd2', size: 8 },
          line: { color: '#00afd2', width: 1 }
        }
      ],
      layout: {
        xaxis: { title: 'Année', autotick: false },
        yaxis: { title: 'Date moyenne de ponte' },
        margin: { t: 0 },
        height
      }
    }
  }
}
